"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPunchHistorical = exports.getPunchTimespansForSelectedDate = exports.findTargetPunchesWithUnifiedPunches = void 0;
const luxon_1 = require("luxon");
const lodash_1 = require("lodash");
const DateManagement_1 = require("../../utils/DateManagement");
const findTargetPunchesWithUnifiedPunches = (selectedDate, timespanPunchGroups = [], payPeriodBreakdownInfo) => {
    const punchWithTimespans = (0, exports.getPunchTimespansForSelectedDate)(timespanPunchGroups, selectedDate);
    const isHistorical = (0, exports.isPunchHistorical)(selectedDate, payPeriodBreakdownInfo);
    if (isHistorical && punchWithTimespans) {
        const updatedPunchWithTimespans = punchWithTimespans.map((punch) => {
            const punchWithHistoricalTags = (0, lodash_1.cloneDeep)(punch);
            if (punchWithHistoricalTags.endSpan) {
                punchWithHistoricalTags.endSpan.isHistorical = true;
            }
            if (punchWithHistoricalTags.startSpan) {
                punchWithHistoricalTags.startSpan.isHistorical = true;
            }
            return punchWithHistoricalTags;
        });
        return updatedPunchWithTimespans;
    }
    return punchWithTimespans;
};
exports.findTargetPunchesWithUnifiedPunches = findTargetPunchesWithUnifiedPunches;
const getPunchTimespansForSelectedDate = (timespanPunchGroups = [], selectedDate) => {
    const punchGroupForSelectedDate = timespanPunchGroups.reduce((accuPunchGroup, currPunchGroup) => {
        if (currPunchGroup.timespanGroupId !== accuPunchGroup.timespanGroupId) {
            currPunchGroup.punchWithTimespans.forEach((punchWithTimespan) => {
                var _a, _b;
                const punchTime = ((_a = punchWithTimespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime.timestamp) ||
                    ((_b = punchWithTimespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime.timestamp);
                const punchDateTime = punchTime
                    ? luxon_1.DateTime.fromISO(punchTime)
                    : null;
                if (punchDateTime && (0, DateManagement_1.areDatesEqual)(selectedDate, punchDateTime)) {
                    accuPunchGroup.punchWithTimespans.push(punchWithTimespan);
                    accuPunchGroup.timespanGroupId = currPunchGroup.timespanGroupId;
                }
            });
        }
        return accuPunchGroup;
    }, { punchWithTimespans: [], timespanGroupId: '' });
    return punchGroupForSelectedDate.punchWithTimespans;
};
exports.getPunchTimespansForSelectedDate = getPunchTimespansForSelectedDate;
const isPunchHistorical = (punchDate, payPeriodBreakdownInfo) => {
    var _a, _b;
    const timeRangeStart = (_a = payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.start_time) !== null && _a !== void 0 ? _a : '';
    const timeRangeEnd = (_b = payPeriodBreakdownInfo === null || payPeriodBreakdownInfo === void 0 ? void 0 : payPeriodBreakdownInfo.current.end_time) !== null && _b !== void 0 ? _b : '';
    const interval = luxon_1.Interval.fromDateTimes(luxon_1.DateTime.fromISO(timeRangeStart), luxon_1.DateTime.fromISO(timeRangeEnd));
    return !interval.contains(punchDate);
};
exports.isPunchHistorical = isPunchHistorical;
